// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__t3d58","myModalContent":"MyModal_myModalContent__mp2RG","active":"MyModal_active__U9RhW"};